export enum RESERVATION_STATUS {
	CONFIRMED = 1,
	STARTED = 2,
	CLOSED = 3,
	CANCELLED = 4,
	PENDING = 5,
}
